import styled from "styled-components";

export const IssueDetailBox = styled.div`
  margin: 0 auto;
  max-width: 500px;
  margin-top: 48px;
`;
